import {
	ChangeDetectionStrategy,
	Component,
	computed,
	effect,
	inject,
	input,
	OnDestroy,
	output,
	signal,
	Signal,
	WritableSignal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { LocationsTreeComponent } from '../locations-tree/locations-tree.component';
import { AuSearchInputComponent } from '../au-search-input/au-search-input.component';
import { LocationSelectorService } from '@app/shared/services/location-selector.service';
import { IBuilding } from '@app/shared/interfaces/building.interfaces';
import { ICMMSLocation } from '@app/pages/cmms/interfaces/cmms-global.interfaces';
import { MatExpansionModule } from '@angular/material/expansion';
import { searchText } from '@app/states/locations/locations.selectors';
import { Store } from '@ngrx/store';
import { LocationAncestryService } from '@app/shared/services/location-ancestry.service.component';

@Component({
	selector: 'locations-list',
	templateUrl: './locations-list.component.html',
	styleUrl: './locations-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatProgressSpinnerModule,
		NgxTolgeeModule,
		MatIconModule,
		LocationsTreeComponent,
		AuSearchInputComponent,
		MatExpansionModule,
	],
})
export class LocationsListComponent implements OnDestroy {
	private readonly locationAncestryService = inject(LocationAncestryService);
	private readonly locationSelectorService = inject(LocationSelectorService);
	private readonly store$ = inject(Store);

	showHeader = input<boolean>(true);
	locationsChanged = output<ICMMSLocation[]>();

	searchText = this.store$.selectSignal(searchText);

	myBuildingsSelections: WritableSignal<ICMMSLocation[]> = signal<ICMMSLocation[]>([]);
	otherLocationsSelections: WritableSignal<ICMMSLocation[]> = signal<ICMMSLocation[]>([]);
	selectedLocations = computed(() => [
		...this.myBuildingsSelections(),
		...this.otherLocationsSelections(),
	]);

	toggleTree = signal<boolean>(false);

	filteredLocationList: Signal<IBuilding[]> =
		this.locationSelectorService.filteredLocations;

	myBuildings: Signal<IBuilding[]> = this.locationSelectorService.filteredMyBuildings;
	loading: Signal<boolean> = computed(
		() => this.filteredLocationList() === null && this.myBuildings() === null
	);

	displayedLocations = computed(() =>
		this.selectedLocations().map(location =>
			this.locationAncestryService.replaceName(location)
		)
	);

	constructor() {
		effect(() => {
			this.locationsChanged.emit(this.selectedLocations());
		});
	}

	filterBuildingsSearch($event: string) {
		this.locationSelectorService.setSearchText($event);
	}

	noSearchResults() {
		if (!this.filteredLocationList() && this.myBuildings().length === 0) {
			return false;
		}

		return this.filteredLocationList().length === 0 && this.myBuildings().length === 0;
	}

	ngOnDestroy() {
		this.locationSelectorService.resetSearchText();
	}
}
